import { RecordHistoryPage } from '@/components/audit-log/RecordHistoryPage'
import { usePathHelper } from '@/hooks/usePathHelper'
import { adminTitleHead } from '@/lib/admin-route-title'
import { auditLogQueries } from '@/lib/services/audit-log/audit-log.query'
import { feeSettingsQueries } from '@/lib/services/fee-settings/fee-settings.query'
import { createFileRoute, notFound } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/settings/fees/history')({
  component: FeeSettingsHistoryPage,
  head: () => adminTitleHead('History', 'Shop fees', 'Settings'),
  loader: async ({ context, params }) => {
    if (
      !context.ability.can('list', 'fee-settings') ||
      !context.ability.can('view', 'audit-logs')
    ) {
      throw notFound()
    }

    await Promise.all([
      context.queryClient.ensureQueryData(
        feeSettingsQueries.detail({ organizationId: params.orgId })
      ),
      context.queryClient.ensureInfiniteQueryData(
        auditLogQueries.record({
          organizationId: params.orgId,
          subject: 'fee-settings',
          recordId: params.orgId,
        })
      ),
    ])
  },
})

function FeeSettingsHistoryPage() {
  const { orgId } = Route.useParams()
  const path = usePathHelper()

  return (
    <RecordHistoryPage
      backLabel="shop fees"
      backLink={path.fees.index().link}
      description="Review fee changes and responsibility acknowledgements."
      organizationId={orgId}
      recordId={orgId}
      recordLabel="Fee settings"
      subject="fee-settings"
    />
  )
}
